import React from 'react'
import "./news.css"
import { Article, articleinfo } from "../../../components/newsbar/articles"
import EachNews from '../eachnews/EachNews'

export default function PremiumNews() {

    const news = articleinfo.map(article => {
        return (
          <EachNews
            key={article.id}
            {...article}
          />
        )
    })        

  return (
    <div className='emas__news'>
        <div className='emas__news-heading'> 
            <h1>Market Commentary</h1>
            <p>Our insights and analysis of the Western Australian electricity market</p>
            <p>Electricity Market Advisory Services Pty Ltd (ABN 663 507 828) does not guarantee, and accepts no legal liability arising from or connected to, the accuracy, reliability, currency or completeness of any material contained on this website. Parties should seek appropriate independent professional advice prior to relying on or entering into any commitment based on material published here.</p>
        </div>
        <section className='emas__news-content'>
            {news}
        </section>
    </div>
  )
}
